// pages/Services.js
import React from "react";
import Header from "../components/home/Header";

import Footer from "../components/home/Footer";
import InternshipProgram from "../components/services/InternshipProgram";




function HrServicePage() {
  return (
    <div>
      <Header />
      <InternshipProgram/>
   
      <Footer />
    </div>
  );
}

export default HrServicePage;
